import { API_PREFIX, API_VERSION, Command, HttpVerbType } from "../Command";
import { GetMachineSmartLockEventsHistoryResData } from "./GetMachineSmartLockEventsHistoryResData";

const ENDPOINT = "/otc/smartlock/events";

export class GetMachineSmartLockEventsHistoryCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "get";

    params: GetMachineSmartLockEventsHistoryReqData = null;

    constructor(installationName: string, machineSerialNumber: string, eventsCount: number) {
        super();
        this.params = new GetMachineSmartLockEventsHistoryReqData(installationName, machineSerialNumber, eventsCount);
    }

    public async execute(): Promise<GetMachineSmartLockEventsHistoryResData> {
        let res = await this.executeCommand(null, null, this.params);
        return new GetMachineSmartLockEventsHistoryResData(res);
    }
}

export class GetMachineSmartLockEventsHistoryReqData {
    installationName: string;
    machineSerialNumber: string;
    eventsCount: number;
    constructor(installationName: string, machineSerialNumber: string, eventsCount: number) {
        this.installationName = installationName;
        this.machineSerialNumber = machineSerialNumber;
        this.eventsCount = eventsCount;
    }
}
